import { useState } from 'react';
import { navLinks, noticeTicker } from '@/mocks/routeData';

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header id="top" className="sticky top-0 z-50 border-b border-stone-200/70 bg-white/85 backdrop-blur">
      {/* 顶部公告滚动条 */}
      <div className="border-b border-orange-100 bg-orange-50/70">
        <div className="mx-auto flex h-8 max-w-7xl items-center gap-2 overflow-hidden px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-medium text-orange-600">
            <i className="ri-sound-module-line text-sm" /> 快讯
          </span>
          <div className="no-scrollbar flex flex-1 items-center gap-6 overflow-x-auto">
            {noticeTicker.map((n) => (
              <span key={n} className="shrink-0 whitespace-nowrap text-xs text-stone-500">{n}</span>
            ))}
          </div>
          <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-xs text-stone-400 md:flex">
            <i className="ri-time-line" /> 09-07 更新
          </span>
        </div>
      </div>

      {/* 主导航 */}
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-orange-500 text-lg font-black text-white">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-mag text-xl font-black text-stone-900">吃瓜线路</span>
            <span className="mt-0.5 text-[11px] tracking-widest text-stone-400">观看顺序 · 线路整理</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.key}
              href={l.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-stone-600 transition hover:bg-orange-50 hover:text-orange-700 whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden items-center gap-2 rounded-full border border-stone-200 bg-stone-50 px-3 py-1.5 text-xs text-stone-400 md:flex">
            <i className="ri-search-line" />
            <input
              className="w-24 bg-transparent text-sm text-stone-700 outline-none placeholder:text-stone-400"
              placeholder="搜剧 / 搜合集"
              aria-label="搜索"
            />
          </div>
          <button className="hidden cursor-pointer whitespace-nowrap rounded-lg bg-stone-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-orange-600 sm:inline-flex">
            补剧到站
          </button>
          <button
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-stone-200 text-stone-600 lg:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <nav className="float-in border-t border-stone-100 bg-white px-4 py-3 lg:hidden">
          <div className="grid grid-cols-2 gap-1">
            {navLinks.map((l) => (
              <a
                key={l.key}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-stone-600 hover:bg-orange-50 hover:text-orange-700"
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}